module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Pin.59450a70.svg";